var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.737 9.2a.689.689 0 01-.49-.206.708.708 0 010-.995L7.57 3.623 3.204-.8a.708.708 0 010-.994.688.688 0 01.981 0l5.348 5.417-5.306 5.37a.69.69 0 01-.49.207z",
    id: "icon-caret_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#3E5A5E",
    transform: "matrix(0 -1 -1 0 9.867 9.867)",
    xlinkHref: "#icon-caret_svg__a",
    fillRule: "evenodd"
  })));
}

export default SvgIconCaret;